



































import { Component, Vue } from 'vue-property-decorator';
import { settingsModule } from '@/store/modules/ModuleSettings';
import ThemePicker from '@/components/theme-picker/index.vue';

@Component({
	name: 'Settings',
	components: {
		ThemePicker
	}
})
/** docs */
export default class extends Vue {
	/** document hooks */
	public get fixedHeader(): any {
		return settingsModule.fixedHeader;
	}

	/** document hooks */
	public set fixedHeader(value: any) {
		settingsModule.changeSetting({ key: 'fixedHeader', value });
	}

	/** document hooks */
	public get showTagsView(): any {
		return settingsModule.showTagsView;
	}

	/** document hooks */
	public set showTagsView(value: any) {
		settingsModule.changeSetting({ key: 'showTagsView', value });
	}

	/** document hooks */
	public get showSidebarLogo(): any {
		return settingsModule.showSidebarLogo;
	}

	/** document hooks */
	public set showSidebarLogo(value: any) {
		settingsModule.changeSetting({ key: 'showSidebarLogo', value });
	}

	/** document hooks */
	public get sidebarTextTheme(): any {
		return settingsModule.sidebarTextTheme;
	}

	/** document hooks */
	public set sidebarTextTheme(value: any) {
		settingsModule.changeSetting({ key: 'sidebarTextTheme', value });
	}

	/** document hooks */
	private themeChange(value: string): any {
		settingsModule.changeSetting({ key: 'theme', value });
	}
}
